import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { DBExportProfile, DBExportProfileMapping, DBExportType } from '@/types/export';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { WriteRequestOptions } from '../requestOptions';

type RequestParams = {
  data: {
    persist: boolean;
    name: string;
    export_type: DBExportType;
    field_mapping: DBExportProfileMapping[];
  };
};

type Response = DBExportProfile;

export const createExportProfile = async (
  scope: RequestScope,
  { data }: RequestParams,
  options: WriteRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    const response = await scopedApi(scope).post<EndpointResponse<Response>>('/export_profile', data, options);
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
